import './AxisArea.css';
export var axisContainerStyle = '_17tgenx0-2-0-1';